import React from 'react';

import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom';

export type LinkProps = MuiLinkProps & Pick<RouterLinkProps, 'to' | 'replace'>;

export const Link: React.FC<LinkProps> = (props) => {
  return <MuiLink {...props} component={RouterLink} />;
};
